import { Category } from "../types/category"

export class FeaturedCategory implements Category {
  id: number
  name: string
  path: string

  constructor(params: Category) {
    this.id = params.id
    this.name = params.name
    this.path = params.path
  }

  get isAll(): boolean {
    return !this.isOther && this.id === 0
  }

  get isOther(): boolean {
    return isNaN(this.id)
  }
}

const allCategory: FeaturedCategory = new FeaturedCategory({
  id: 0,
  name: "すべて",
})
const otherCategory: FeaturedCategory = new FeaturedCategory({
  id: NaN,
  name: "…",
  path: "",
})

export class FeaturedCategories {
  categories: Array<FeaturedCategory>
  selectedCategory: FeaturedCategory

  constructor(categories?: Array<Category>, selectedCategory?: Category) {
    if (selectedCategory != null) {
      this.selectedCategory = new FeaturedCategory(selectedCategory)
    }

    if (!categories) {
      this.categories = [allCategory, otherCategory]
      return
    }
    if (selectedCategory == null) {
      this.categories = [
        allCategory,
        this.wrapCategories(categories),
        otherCategory,
      ].flat()
      return
    }

    const base = [
      allCategory,
      this.wrapCategories(categories),
      otherCategory,
    ].flat()
    if (base.findIndex((c) => c.id == this.selectedCategory.id) == -1) {
      this.categories = [
        allCategory,
        this.wrapCategories(categories),
        this.selectedCategory,
        otherCategory,
      ].flat()
      return
    }
    this.categories = base
  }

  wrapCategories(categories: Array<Category>): Array<FeaturedCategory> {
    return categories.map((c) => new FeaturedCategory(c))
  }

  static build(
    categories?: Array<Category>,
    selectedCategory?: Category
  ): Array<FeaturedCategory> {
    const instance = new FeaturedCategories(categories, selectedCategory)
    return instance.categories
  }
}

const filterCategoriesRecursively = (
  id: number,
  categories: Array<Category>
): Category => {
  for (let i = 0; i < categories.length; i++) {
    const cat = categories[i]
    if (cat.id === id) {
      return cat
    }
    if (cat.children && cat.children.length > 0) {
      const child = filterCategoriesRecursively(id, cat.children)
      if (child) {
        return child
      }
    }
  }
  return null
}

export class Categories {
  static find(id: number, categories: Array<Category>): Category {
    if (!id || categories.length == 0) {
      return null
    }
    return filterCategoriesRecursively(id, categories)
  }
}
